/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_SpottingInputs */

const en_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPOTTING`)
};

const fr_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REPERAGE`)
};

const de_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPEKTIEREN`)
};

const it_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AVVISTAMENTO`)
};

const ru_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`НАБЛЮДЕНИЕ`)
};

const es_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUNTEO`)
};

const zh_cn2_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现`)
};

const ja_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポッティング`)
};

const hi_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोलना`)
};

const pt_pt2_ccsl_export_header_spotting = /** @type {(inputs: Ccsl_Export_Header_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AVISTAMENTO`)
};

/**
* | output |
* | --- |
* | "SPOTTING" |
*
* @param {Ccsl_Export_Header_SpottingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_spotting = /** @type {((inputs?: Ccsl_Export_Header_SpottingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_SpottingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_spotting(inputs)
	if (locale === "de") return de_ccsl_export_header_spotting(inputs)
	if (locale === "it") return it_ccsl_export_header_spotting(inputs)
	if (locale === "ru") return ru_ccsl_export_header_spotting(inputs)
	if (locale === "es") return es_ccsl_export_header_spotting(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_spotting(inputs)
	if (locale === "ja") return ja_ccsl_export_header_spotting(inputs)
	if (locale === "hi") return hi_ccsl_export_header_spotting(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_spotting(inputs)
	return en_ccsl_export_header_spotting(inputs)
});